<template>
  <validator name="messageValidator">
    <form novalidate>
      <div class="mdl-grid mdl-grid--nesting">
        <div class="mdl-cell mdl-cell--12-col mdl-shadow--2dp">
        <div class="mdl-card fill">
          <div class="ga-form-title">
            <h2 class="ga-title-text">{{'newDelayed.label.title' | label}}</h2>
          </div>
          <div class="mdl-card__supporting-text fill">
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill dirty-check">
              <div class="iconized">
                <input class="mdl-textfield__input" :type="emailInputType" id="recipients" initial="off"
                v-validate:recipients="['emailArray']"  v-model="message['recipients']">
                <span class="fas" :class="{'fa-eye': isFaEye, 'fa-eye-slash': isFaEyeSlash}" @click="toggleShowEmail">&nbsp;</span>
              </div>
              <label class="mdl-textfield__label ga-required" for="recipients">{{'newDelayed.label.recipients' | label}}</label>
              <span class="validation-error mdl-textfield__error" v-if="$messageValidator.recipients.emailArray">{{'newDelayed.validation.recipients' | label}}</span>
              <span class="ga-input-instruction" v-if="!$messageValidator.recipients.emailArray">{{'newDelayed.instruction.recipients' | label}}</span>
            </div>
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill dirty-check">
              <input class="mdl-textfield__input" type="text" id="subject" initial="off"
                     v-validate:subject="['required']" v-model="message['subject']">
              <label class="mdl-textfield__label ga-required" for="subject">{{'newDelayed.label.subject' | label}}</label>
              <span class="validation-error mdl-textfield__error" v-if="$messageValidator.subject.required">{{'general.validation.required' | label}}</span>
              <span class="ga-input-instruction" v-if="!$messageValidator.subject.required">{{'newDelayed.instruction.subject' | label}}</span>
            </div>
            <!--<div class="mdl-textfield mdl-js-textfield mdl-textfield&#45;&#45;floating-label fill">-->
            <text-area :body.sync="message['messageBody']" :placeholder="getLabel('newDelayed.label.messageBody')" component-id="newmessage" @loadstart="textareaLoadStart" @loadend="textareaLoadEnd">
            </text-area>
            <input v-show="false" class="mdl-textfield__input" type="text" id="messageBody" initial="off" v-model="message['messageBody']" v-validate:messageBody="['required']">
            <span class="validation-error mdl-textfield__error" v-if="$messageValidator.messagebody.required">{{'newDelayed.validation.messageBody' | label}}</span>
            <span class="ga-input-instruction" v-if="!$messageValidator.messagebody.required">{{'newDelayed.instruction.messageBody' | label}}</span>
            <!--</div>-->
            <div class="mdl-grid inner-grid">
              <div class="mdl-cell mdl-cell--6-col">
                <div v-el:attachment class="attachment-label form-label">{{'newDelayed.label.attachments' | label}}
                </div>
              </div>
              <div class="mdl-cell mdl-cell--6-col">
                <div v-el:addAttachment v-on:click="addAttachment()"
                  class="mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab" value="">
                  <i class="material-icons">add</i>
                </div>
                  <input class="display-none" v-el:file type="file" v-on:change="uploadFile()" multiple/>
              </div>
              <span class="ga-input-instruction">{{'newDelayed.instruction.attachments' | label}}</span>
            </div>
            <div class="mdl-grid inner-grid">
              <div class="mdl-cell mdl-cell--12-col">
                <attachment v-for="attachment in message['attachments']" :file.sync=attachment :attachments.sync=message['attachments']></attachment>
              </div>
            </div>
            <div v-if="message.status!=='SENT'" class="mdl-card__actions">
              <div class="card-grid mdl-grid inner-grid">
                <div class="mdl-cell mdl-cell--4-col">
                  <div class="mdl-button mdl-js-button mdl-button--raised fill"
                       v-on:click="backToReg()">
                      {{'newDelayed.button.back' | label}}
                  </div>
                </div>
                <div class="mdl-cell mdl-cell--4-col">
                </div>
                <div class="mdl-cell mdl-cell--4-col">
                  <div v-el:saveButton class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored fill"
                       v-on:click="validate()">
                    {{'newDelayed.button.save' | label}}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
      </div>
    </form>
  </validator>
</template>

<script>
  var file = require('api/File')
//  var config = require('common/config')
  var getters = require('common/store/getters')
  var label = require('vue').filter('label')
  var appConfig = require('vue').filter('appConfig')
  module.exports = {
    ready: function () {
      window.componentHandler.upgradeAllRegistered()
    },
    vuex: {
      getters: getters
    },
    props: {
      model: Object,
      registration: Boolean,
      initDate: ''
    },
    components: {
      'attachment': require('c/components/Attachment'),
      'text-area': require('c/components/TextArea'),
      mdlSelect: require('c/components/Select')
    },
    methods: {
      textareaLoadStart: function () {
        console.log('textareaLoadStart')
        this.$dispatch('loading', true)
      },
      textareaLoadEnd: function () {
        console.log('textareaLoadEnd')
        this.$dispatch('loading', false)
      },
      validate: function () {
        var self = this
        if (self.uploading) {
          return
        }
        this.$validate(true, function () {
          if (self.$messageValidator.invalid) {
            return
          }
          self.$dispatch('message-valid', self.message)
        })
      },
      uploadFile: function () {
        var self = this
        var files = this.$els.file.files
        var fileTypes = appConfig('fileTypes')
        // var maxMessageSize = appConfig('maxMessageSize')
        var maxFileSize = appConfig('maxFileSize')
        Object.keys(files).forEach(function (i) {
          if (fileTypes.indexOf(files[i].type) === -1) {
            self.$dispatch('show-error', new Error(label('general.file.error.unsupported')))
            return
          }
          if (files[i].size > maxFileSize) {
            self.$dispatch('show-error', new Error(label('newScheduled.validation.attachments.maxFileSize')))
            return
          }
          // not needed anymore: any attachment becomes a link
          // if (self.totalAttachmentSize + files[i].size > maxMessageSize) {
          //   self.$dispatch('show-error', new Error(label('newScheduled.validation.attachments.maxSize')))
          //   return
          // }
          var f = files[i]

          var attachment = {
            'fileName': f.name,
            'fileSize': f.size,
            'contentType': f.type
          }
          self.message.attachments.push(attachment)
          self.uploading = true
          file.uploadFile(files[i], function (response) {
            f.index = self.message.attachments.length
            var sendAsLink = false
            if ((f.type).startsWith('video')) {
              sendAsLink = true
            }
            // all attachments must be a link
            sendAsLink = true
            attachment.s3Key = response.data.Key
            attachment.sendAsLink = sendAsLink
            attachment.__finished = true
            self.$broadcast('refresh')
            self.uploading = false
          }, function (err) {
            // attachment.__finished = true
            var index = self.message.attachments.indexOf(attachment)
            self.message.attachments.splice(index, 1)
            self.$broadcast('refresh')
            self.$dispatch('show-error', err.data)
            self.uploading = false
          })
        })
      },
      clearFileInput: function () {
        this.$els.file.value = ''
      },
      getLabel: function (key) {
        return label(key)
      },
      getDelayMessagePeriod: function () {
        return this.message['delayMessagePeriod'] ? this.message['delayMessagePeriod'].toString() : '1'
      },
      getAppConfig: function (key) {
        return appConfig(key)
      },
      backToReg: function () {
        if (this.registration) {
          this.$dispatch('back-to-reg')
        } else {
          this.$router.go('/app/managed')
        }
      },
      addAttachment: function () {
        var self = this
        if (!self.uploading) {
          self.clearFileInput()
          self.$els.file.click()
        }
      },
      toggleShowEmail: function () {
        this.emailInputType = (this.isFaEye ? 'text' : 'password')
        this.isFaEye = !this.isFaEye
        this.isFaEyeSlash = !this.isFaEyeSlash
      }
    },
    data: function () {
      return {
        message: {
          recipients: '',
          subject: '',
          messageBody: '',
          attachments: []
        },
        user: {},
        uploading: false,
        isFaEye: true,
        isFaEyeSlash: false,
        emailInputType: 'password'
      }
    },
    watch: {
      'model': {
        handler: function (model) {
          this.message = this.model
          // this.$broadcast('body-changed', model.messageBody)
          this.$nextTick(function () {
            document.querySelectorAll('.dirty-check').forEach(function (el) {
              var input = el.querySelector('input') || el.querySelector('textarea')
              if (input && input.value) {
                el.MaterialTextfield.checkDirty()
              }
            })
          })
        },
        deep: true
      },
      'uploading': function (newVal, oldlVal) {
        var self = this
        var button = self.$els.savebutton
        if (newVal) {
          button.classList.add('gray')
        } else {
          button.classList.remove('gray')
        }
      }
    },
    events: {
      'remove-file': function (f) {
        var self = this
        file.remove(f.s3Key, f.id, function (response) {
        }, function (err) {
          self.$dispatch('show-error', err)
        })
      }
    },
    computed: {
      totalAttachmentSize: function () {
        var result = 0
        this.message.attachments.forEach(function (attachment) {
          result += attachment.size
        })
        return result
      },
      defaultTimeZone: function () {
        if (self.user) {
          return this.user.timeZone
        } else {
          var moment = require('moment-timezone')
          return moment.tz.guess()
        }
      },
      limit: function () {
        var moment = require('moment-timezone')
        var from = moment().subtract(1, 'days')
        return [{
          type: 'fromto',
          from: from
        }]
      }
    }
}
</script>

<style scoped>
  .padding-top {
    padding-top: 20px;
  }
  .gray {
    background-color: rgba(190,190,190,.2) !important;
    color: black;
  }
</style>



// WEBPACK FOOTER //
// MessageForm.vue?20cbbe72